export { useCheckEmailAvailability } from '@src/features/customers/auth/identification/hooks/useCheckEmailAvailability';
export { IDENTIFICATION_ORIGIN } from '@src/features/customers/auth/identification/types';
export type {
  EmailIdentificationPayload,
  IdentificationOrigin,
} from '@src/features/customers/auth/identification/types';
export { decideAuthRoute } from '@src/features/customers/auth/identification/core/decideAuthRoute';
export { AuthMethodDivider } from './components/AuthMethodDivider';
export { EmailIdentificationCard } from './components/EmailIdentificationCard';
export { useEmailIdentificationForm } from './hooks/useEmailIdentificationForm';
